import { GeneralLink } from "@customTypes/generalLink";
import styles from "./C271_ThinkCtaContainer.module.scss";
import C271_ThinkCtaItem, { CtaItem } from "./C271_ThinkCtaItem";

export interface ThinkCtaContainerProps {
  ctaContent: ({
    fields: { cta: GeneralLink; description: string };
    component: string;
  } & CtaItem)[];
  title?: string;
}

type GlobalContentLite = {
  templateId?: "T07" | "T03" | string;
  isThinkBlue?: boolean;
};

export const ThinkCtaContainer = (props: {
  content: ThinkCtaContainerProps;
  templateId?: string;
  globalContent?: GlobalContentLite;
}) => {
  const { content } = props;
  const { title, ctaContent = [] } = content;

  const isBlue =
    props?.templateId === "T07" ||
    props?.globalContent?.templateId === "T07" ||
    props?.globalContent?.isThinkBlue;

  const items = ctaContent.slice(0, 3);

  return (
    <div className="flex flex-col">
      {title && <h3 className={styles["title"]}>{title}</h3>}
      <div className="flex flex-wrap gap-6">
        {items.map((item, index) => (
          <C271_ThinkCtaItem key={index} ctaContent={item} isBlue={isBlue} />
        ))}
      </div>
    </div>
  );
};

export default ThinkCtaContainer;
